<template>
  <div data-test="TFormRowTextInput">
    <div v-if="props.label" class="mb-1 flex justify-between">
      <span class="font-bold text-sm">
        <label :for="props.id" class="block font-semibold">
          {{ props.label }}
        </label>
      </span>
      <slot name="additional-label" />
    </div>

    <div>
      <input
        :id="props.id"
        ref="inputRef"
        :value="props.modelValue"
        :name="props.id"
        :type="props.type"
        :autocomplete="props.autocomplete ?? 'off'"
        :class="[
          'block w-full appearance-none rounded-md border px-3 py-2 text-sm placeholder:text-neutral-500 focus:border-primary-500 focus:border-2 focus:outline-hidden focus:ring-primary-500',
          props.hasError ? 'border-danger-500' : 'border-neutral-400',
        ]"
        :placeholder="props.placeholder"
        :required="props.required"
        :pattern="props.pattern ?? '[\\s\\S]*'"
        @input="updateInput"
      />
    </div>
    <span v-if="errorMessage" class="text-xs text-danger-500">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['update:modelValue', 'textChanged']);

const props = defineProps<{
  id: string;
  label?: string;
  type: string;
  autocomplete?: string;
  modelValue: string;
  hasError?: boolean;
  errorMessage?: string;
  placeholder?: string;
  required?: boolean;
  pattern?: string;
  dataTestName?: string;
  characterLimit?: number;
  onInternalError?: () => void; // a function called when the internal error message is set
  onResetErrorState?: () => void; // a function called when the internal error message is reset
}>();

const inputRef = ref();

function focus() {
  inputRef.value.focus();
}

defineExpose({
  focus,
});

watch(props, () => {
  emit('textChanged', props.modelValue);
});

function updateInput(event) {
  emit('update:modelValue', event.target.value);
}
</script>
